import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const MESSAGES = {
  connection: {
    title: "Sign in failed",
    description: "Could not connect to the server. Check your internet connection.",
  },
  credentials: {
    title: "Sign in failed",
    description: "Invalid username or password.",
  },
};

/**
 * @param {object} props
 * @param {boolean} props.open
 * @param {(open: boolean) => void} props.onOpenChange
 * @param {"connection" | "credentials"} props.kind
 */
export function LoginErrorDialog({ open, onOpenChange, kind }) {
  const { title, description } = MESSAGES[kind] || MESSAGES.credentials;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" onClick={() => onOpenChange(false)}>
            OK
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
